import React from "react";
import {useLocaleContext} from "../../../../context/LocaleContext";

export default () => {
    const {get} = useLocaleContext();

    return (
        <>
            <h1>{get('broadcast.overlay.starting.title')}</h1>
        </>
    );
}
